module.exports = __webpack_public_path__ + "static/gonczarowski-hex-gray-2c61e865a9baae7dee13a32832b2ecbb.png";